/**
 * Removes a key from a dictionary and returns the a new object. Useful for deletes on reducers
 * https://github.com/erikras/react-redux-universal-hot-example/issues/962#issuecomment-219354496
 * @param myObj
 * @param deleteKey
 * @returns {*}
 */
export function removeByKeyHelper(myObj, deleteKey) {
  const newObj = { ...myObj };
  delete newObj[deleteKey];
  return newObj;
}

/**
 * Removes a list of entries from a dictionary and returns the a new object. Useful for multiple deletes
 * when leaving a case on reducers
 * @param myObj
 * @param attributeId
 * @param attributeName
 * @returns {*}
 */
export function removeByListOfAttributeIdsHelper(myObj, attributeId, attributeName) {
  const objFiltered = Object.keys(myObj)
    .filter((key) => myObj[key][attributeName] !== attributeId)
    .reduce((result, current) => {
      result[current] = myObj[current];
      return result;
    }, {});
  return objFiltered;
}

export function equalsSet(a, b) {
  const setA = a instanceof Set ? a : new Set(a);
  const setB = b instanceof Set ? b : new Set(b);

  return setA.size === setB.size && [...setA].every((value) => setB.has(value));
}
